<template>
  <div class="mapNavigation">
    <v-btn
      v-if="$vuetify.breakpoint.xsOnly"
      @click="toggleDrawerMenu"
      class="mapNavigation__menu"
      icon
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <div class="mapNavigation__wrapper">
      <div class="mapNavigation__loading" v-if="loading">
        <v-progress-circular indeterminate />
      </div>

      <v-bottom-navigation
        v-model="selectedPeriod"
        justify="center"
        color="primary"
      >
        <v-btn
          value="0"
          x-small
          outlined
          color="black"
          elevation="0"
          @click="setPeriod('0')"
        >
          {{ $t('dashboard.navigationPeriod.button.today') }}
        </v-btn>
        <v-btn
          value="1"
          x-small
          outlined
          color="black"
          elevation="0"
          @click="setPeriod('1')"
        >
          {{ $t('dashboard.navigationPeriod.button.tomorrow') }}
        </v-btn>
        <v-btn
          value="2"
          x-small
          outlined
          color="black"
          elevation="0"
          @click="setPeriod('2')"
        >
          {{ $t('dashboard.navigationPeriod.button.week') }}
        </v-btn>
      </v-bottom-navigation>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MapNavigation',

  computed: {
    ...mapGetters(['isMenuDrawerOpen']),

    selectedPeriod: {
      get() {
        return this.$store.state.dashboard.selectedPeriod
      },
      set(value) {
        this.$store.commit('dashboard/setSelectedPeriod', value)
      },
    },

    loading: {
      get() {
        return this.$store.state.dashboard.loading
      },
      set(value) {
        this.$store.commit('dashboard/setIsLoading', value)
      },
    },
  },

  methods: {
    ...mapMutations(['setIsMenuDrawerOpen']),

    toggleDrawerMenu() {
      this.setIsMenuDrawerOpen(!this.isMenuDrawerOpen)
    },

    setPeriod(value) {
      this.$root.$emit('selectedPeriod', value)
    },
  },
}
</script>
